module.exports = __webpack_public_path__ + "assets/img/logo-MINI.f75ca6ca.png";